module.exports = __webpack_public_path__ + "img/9788952734082.21afabd1.jpg";